import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as enums from './helpers/enums';
import * as constants from '@/helpers/constants';
import Vue3TouchEvents from 'vue3-touch-events';
import * as Sentry from '@sentry/vue';
import Clarity from '@microsoft/clarity';

// Styles
import '@/style/main.scss';

// Translation
import { i18n } from '@/i18n';
import eventBus from '@/eventBus';

const app = createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(Vue3TouchEvents);

/* Sentry */
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV,
  debug: import.meta.env.DEV,
  release: import.meta.env.VITE_RELEASE,
  autoSessionTracking: true,
  ignoreErrors: ['ApiAlreadyNotified', 'Ignore sentry error'],
  tracesSampleRate: 1.0,
});

Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);

try {
  window.clarity('consentv2', {
    ad_Storage: 'granted',
    analytics_Storage: 'granted',
  });
} catch (e) {
  console.error('Clarity consentv2 error', e);
}

// On development log errors into console
app.config.errorHandler = function (error, vm, info): void {
  if (import.meta.env.DEV) {
    console.error(error, vm, info);
  }
};

app.config.globalProperties.$enums = enums;
app.config.globalProperties.$constants = constants;
app.config.globalProperties.$eventBus = eventBus;

app.mount('#app');
